import React from "react";
import { validationUtils } from "../validation/Validation";
import { ValidatableFormGroup } from "../components/ValidatableFormGroup"
import { ICreditCardInfo, IPaymentInfoChangeResult } from "../classes/Domain";
import Utilities from "../classes/Utilities";
import { Rifm } from 'rifm';
import _ from "lodash";

interface IProps {
    creditCard: ICreditCardInfo,
    onChange(result: IPaymentInfoChangeResult): void,
    disabled?: boolean,
    errors: any
}

interface IState {

}

class CreditCard extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
    }

    onCreditCardChange(value: string, prop: string) {
        const updatedCc = { ...this.props.creditCard, instrumentType: "CC" } as ICreditCardInfo;
        updatedCc[prop] = value.trim().toUpperCase();

        if (prop === "cardExpirationFull") {
            let expMonth = 0;
            let expYear = 0;
            const [month = "", year = ""] = value.split('/');

            if (month) {
                expMonth = parseInt(month.replace(/^\0+/, ""), 10)
            }

            if (year) {
                expYear = parseInt(year, 10)
            }

            updatedCc["cardExpirationMonth"] = expMonth;
            updatedCc["cardExpirationYear"] = expYear;
        }

        this.props.onChange({ paymentInstrument: updatedCc });
    }

    render() {
        return (<div>
            <ValidatableFormGroup
                label="Cardholder First Name"
                value={Utilities.getStringValueSafe(this.props.creditCard, "cardHolderFirstName") || ""}
                placeholder="Cardholder First Name"
                disabled={this.props.disabled}
                validated={null !== this.props.errors}
                validationError={validationUtils.getValidationErrorFor(this.props.errors, "cardHolderFirstName")}
                onChange={(e) => { this.onCreditCardChange(e.target.value, "cardHolderFirstName") }} />

            <ValidatableFormGroup
                label="Cardholder Last Name"
                value={Utilities.getStringValueSafe(this.props.creditCard, "cardHolderLastName") || ""}
                placeholder="Cardholder Last Name"
                disabled={this.props.disabled}
                validated={null !== this.props.errors}
                validationError={validationUtils.getValidationErrorFor(this.props.errors, "cardHolderLastName")}
                onChange={(e) => { this.onCreditCardChange(e.target.value, "cardHolderLastName") }} />

            <Rifm
                accept={/\d/g}
                format={Utilities.formatInteger}
                value={Utilities.getStringValueSafe(this.props.creditCard, "cardNumber") || ""}
                onChange={(v) => { this.onCreditCardChange(v, "cardNumber") }}>
                {({ value, onChange }) => (
                    <ValidatableFormGroup
                        label="Card Number"
                        value={value}
                        placeholder="Card Number"
                        disabled={this.props.disabled}
                        validated={null !== this.props.errors}
                        validationError={validationUtils.getValidationErrorFor(this.props.errors, "cardNumber")}
                        onChange={(e) => { onChange(e) }}
                        pattern="[0-9]*"
                        inputmode="numeric" />
                )}
            </Rifm>

            <Rifm
                accept={/\d/g}
                format={Utilities.formatCreditCardExpiration}
                value={Utilities.getStringValueSafe(this.props.creditCard, "cardExpirationFull") || ""}
                onChange={(v) => { this.onCreditCardChange(v, "cardExpirationFull") }}>
                {({ value, onChange }) => (
                    <ValidatableFormGroup
                        label="Card Expiration (Month/Year)"
                        placeholder="MM/YY"
                        disabled={this.props.disabled}
                        value={value}
                        validated={null !== this.props.errors}
                        validationError={validationUtils.getValidationErrorFor(this.props.errors, "cardExpirationFull")}
                        onChange={(e) => { onChange(e) }}
                        pattern="[0-9]*"
                        inputmode="numeric" />
                )}
            </Rifm>
        </div>);
    }
}

export default CreditCard;